var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNav4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 15.5C8.82977 15.5 6.01065 17.0306 4.21585 19.406C3.82956 19.9172 3.63641 20.1728 3.64273 20.5183C3.64761 20.7852 3.81521 21.1219 4.02522 21.2867C4.29704 21.5 4.67372 21.5 5.42708 21.5H18.5726C19.326 21.5 19.7027 21.5 19.9745 21.2867C20.1845 21.1219 20.3521 20.7852 20.357 20.5183C20.3633 20.1728 20.1701 19.9172 19.7839 19.406C17.9891 17.0306 15.1699 15.5 11.9999 15.5Z",
    stroke: "#631517",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 12.5C14.4851 12.5 16.4999 10.4853 16.4999 8C16.4999 5.51472 14.4851 3.5 11.9999 3.5C9.51457 3.5 7.49985 5.51472 7.49985 8C7.49985 10.4853 9.51457 12.5 11.9999 12.5Z",
    stroke: "#631517",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav4);
export default __webpack_public_path__ + "static/media/Nav4.3c5dbc5db41d2c1926293b2ee9f306c3.svg";
export { ForwardRef as ReactComponent };